import { collection, getDocs, query, orderBy, doc, addDoc, serverTimestamp, deleteDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

import { auth, firestore, storage } from "./FirebaseService";

const usersCollectionName = "users";

export const uploadGlucoseFile = async (patientId, file, phase) => {
  const fileId = crypto.randomUUID();
  // Extract the extension from the original file name
  const extension = file.name.split('.').pop();
  const storagePath = `glucoseFiles/${patientId}/${fileId}.${extension}`;
  const fileRef = ref(storage, storagePath);

  // Upload to Storage
  await uploadBytes(fileRef, file);

  // Prepare metadata
  const metadata = {
    name: file.name,
    storagePath,
    phase,
    size: file.size,
    uploadDate: serverTimestamp(),
    uploaderId: auth.currentUser.uid
  };

  // Save metadata in Firestore
  const docRef = await addDoc(
    collection(firestore, `${usersCollectionName}/${patientId}/glucoseFiles`),
    metadata
  );

  return { id: docRef.id, ...metadata, uploadDate: new Date() };
};

// Fetch glucose files metadata for a patient
export const fetchGlucoseFiles = async (patientId) => {
  const q = query(
    collection(firestore, `${usersCollectionName}/${patientId}/glucoseFiles`),
    orderBy("uploadDate", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    uploadDate: doc.data().uploadDate?.toDate ? doc.data().uploadDate.toDate() : null
  }));
};

export const deleteGlucoseFile = async (patientId, file) => {
  await deleteObject(ref(storage, file.storagePath));
  await deleteDoc(doc(firestore, `${usersCollectionName}/${patientId}/glucoseFiles/${file.id}`));
};

export const getFileDownloadUrl = async (storagePath) => {
  const fileRef = ref(storage, storagePath);
  return await getDownloadURL(fileRef);
};

export const getProfilePictureUrl = async (userId, imageSize, updatedAt) => {
  if (updatedAt <= 0) return null;

  try {
    const storagePath = `profilePicturesV2/${userId}/profile_${imageSize}.jpg`;
    const fileRef = ref(storage, storagePath);

    // Get download URL with cache busting using updatedAt timestamp
    const downloadUrl = await getDownloadURL(fileRef);

    // Add cache busting parameter to force refresh when image is updated
    const urlWithCacheBusting = `${downloadUrl}&t=${updatedAt}`;

    return urlWithCacheBusting;
  } catch (error) {
    // Handle case where profile picture doesn't exist
    if (error.code === 'storage/object-not-found') {
      return null; // or return a default profile picture URL
    }
    throw error;
  }
};